import { useMemo } from 'react'
import { Box, Heading, Text } from '@grupoboticario/flora-react'
import { useTranslation } from 'react-i18next'

import Divider from './Divider'
import { useTracking } from '../TrackingContext'

const Receiver = () => {
  const data = useTracking()
  const info = useMemo(() => (!data ? '' : data.orderTraceabilityModel), [data])
  const { t } = useTranslation()

  if (!data) return <div />
  if (!info.nmRecebedor && !info.cargoRecebedor) return <div />

  return (
    <>
      <Divider />
      <Box css={{ display: 'flex' }}>
        {info.nmRecebedor && (
          <Box css={{ width: '50%' }}>
            <Heading as="h3" css={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, marginBottom: '4px' }}>
              {t('receivedBy')}:
            </Heading>
            <Text className="text1">{info.nmRecebedor}</Text>
          </Box>
        )}

        {info.cargoRecebedor && (
          <Box css={{ width: '50%' }}>
            <Heading as="h3" css={{ fontSize: '16px', lineHeight: '24px', fontWeight: 700, marginBottom: '4px' }}>
              {t('recipientRelationship')}:
            </Heading>
            <Text className="text1">{info.cargoRecebedor}</Text>
          </Box>
        )}
      </Box>
    </>
  )
}

export default Receiver
